const deepClone = source => {
    const target = {};

    Reflect.ownKeys(source).forEach(key => {
        const sourceValue = source[key];
        let targetValue = sourceValue;

        //String types can have a typeof value of object
        if(typeof sourceValue === 'object' && !(sourceValue instanceof String)){
            targetValue = deepClone(sourceValue);
        }

        target[key] = targetValue;
    });

    return target;
}

export {
    deepClone
}